// ─────────────────────────────────────────────────────────────────────────────
// icons.js — glyphs for the row context menu and its modals. Stroked, inheriting
// `currentColor`, so the menu item's colour (including the red delete row)
// carries straight through.
// ─────────────────────────────────────────────────────────────────────────────
const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 24 24",
};

export const EyeIcon = ({ size = 16 }) => (
  <svg width={size} height={size} {...base}>
    <path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12Z" />
    <circle cx="12" cy="12" r="2.6" />
  </svg>
);

export const PencilIcon = ({ size = 16 }) => (
  <svg width={size} height={size} {...base}>
    <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z" />
  </svg>
);

export const CopyIcon = ({ size = 16 }) => (
  <svg width={size} height={size} {...base}>
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" />
  </svg>
);

export const CheckIcon = ({ size = 16 }) => (
  <svg width={size} height={size} {...base}>
    <path d="m5 12.5 4.5 4.5L19 7" />
  </svg>
);

export const TrashIcon = ({ size = 16 }) => (
  <svg width={size} height={size} {...base}>
    <path d="M4 7h16M10 11v6M14 11v6" />
    <path d="M6 7l1 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-12" />
    <path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

export const WarnTriangleIcon = ({ size = 26 }) => (
  <svg width={size} height={size} {...base}>
    <path d="M12 4.5 2.6 20h18.8L12 4.5Z" />
    <path d="M12 10v4.5M12 17.4v.1" />
  </svg>
);

export const CloseIcon = ({ size = 18 }) => (
  <svg width={size} height={size} {...base}>
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

export const DownloadIcon = ({ size = 16 }) => (
  <svg width={size} height={size} {...base}>
    <path d="M12 3v11m0 0 4-4m-4 4-4-4" />
    <path d="M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2" />
  </svg>
);
